import { Text } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";

type Props = {
	guess?: string;
	count: number;
	maxValue: number;
	barContainerWidth: number;
	barColor?: string;
	barValue?: string;
};

const Distributionbar = ({
	guess,
	count,
	maxValue,
	barContainerWidth,
	barColor,
	barValue,
}: Props) => {
	const theme = useAppTheme();

	const getBarColor = (guessNumber: number) => {
		if (guessNumber <= 2) {
			return theme.colors.progress.high;
		}
		if (guessNumber <= 4) {
			return theme.colors.progress.medium;
		}
		return theme.colors.progress.low;
	};

	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			{guess && <Text variant="labelMedium">{guess}</Text>}
			<Box
				width={barContainerWidth}
				height={24}
				// backgroundColor={theme.colors.progress.none}
				borderRadius={4}
			>
				<Box
					height="100%"
					width={`${(count / maxValue) * 100}%`}
					borderRadius={4}
					justifyContent="center"
					paddingLeft={8}
					backgroundColor={barColor || getBarColor(Number(guess))}
				>
					<Text
						variant="labelMedium"
						style={{ color: theme.colors.onSecondaryContainer }}
					>
						{barValue || count}
					</Text>
				</Box>
			</Box>
		</Box>
	);
};

export default Distributionbar;
